import axios from 'axios';

let api, mock;

const BASE_URL = 'http://127.0.0.1:3000';

export function http(name) {
    createHttp(name);

    switch (name) {
        case 'docs':
            return mock;
        case 'api':
            return api;
        case 'axios':
            return axios;
        default:
            return api;
    }
}

function createHttp(name) {
    if (!mock && name === 'docs') {
        mock = axios.create({
            baseURL: process.env.NODE_ENV === 'development' ? process.env.VUE_APP_BASE_URL : BASE_URL,
            validateStatus: false
        });

        mock.interceptors.request.use((request) => {
            const sid = sessionStorage.getItem('sid');
            if (sid) {
                request.headers['Authorization'] = `Bearer ${sid}`;
            }
            return request;
        });
    }
    if (!api && (!name || name === 'api')) {
        api = axios.create({
            baseURL: `${loadBaseUrl()}/api`,
            validateStatus: false
        });
    }
}

function loadBaseUrl() {
    try {
        let baseUrl = document.querySelector('meta[name="api"]').content;
        if (baseUrl !== '__API__') {
            return baseUrl;
        }
        return process.env.VUE_APP_BASE_URL;
    } catch (err) {
        return process.env.VUE_APP_BASE_URL;
    }
}

export default http;
